import { format, startOfDay } from "date-fns";
import { useEffect, useState } from "react";

/**
 * Device-local "today" with visibility-change + next-midnight refresh.
 * Solves Pitfall 4: today doesn't update after device returns from background
 * (e.g., LAX→JFK overnight). Diverges from server-side users.timezone (D-06).
 */
export function useToday(): { today: Date; todayIso: string } {
	const [today, setToday] = useState(() => startOfDay(new Date()));

	useEffect(() => {
		const refresh = () => setToday(startOfDay(new Date()));
		const onVisibility = () => {
			if (document.visibilityState === "visible") refresh();
		};
		document.addEventListener("visibilitychange", onVisibility);

		// Timer to flip at next midnight (+1s slack)
		const nextMidnight = startOfDay(
			new Date(Date.now() + 86_400_000),
		).getTime();
		const msUntilMidnight = nextMidnight - Date.now();
		const timer = window.setTimeout(refresh, msUntilMidnight + 1000);

		return () => {
			document.removeEventListener("visibilitychange", onVisibility);
			window.clearTimeout(timer);
		};
	}, []);

	return { today, todayIso: format(today, "yyyy-MM-dd") };
}
